export function request(userId, bets, channel, override) {
    return (dispatch, getState) => {
        dispatch({
            type: 'BETSLIP_ACCEPT_REFERRED_REQUEST',
            userId,
            bets,
            channel,
            selections: getState().selections.get('items'),
            override
        });
    };
}

export function error(userId, errors) {
    return {
        type: 'BETSLIP_ACCEPT_REFERRED_ERROR',
        userId,
        errors
    };
}

export function finish(userId, { bets }) {
    return {
        type: 'BETSLIP_ACCEPT_REFERRED_FINISH',
        userId,
        bets
    };
}

export function clear(userId) {
    return {
        type: 'BETSLIP_ACCEPT_REFERRED_CLEAR',
        userId
    };
}
